export default "__VITE_ASSET__C3m8kSA8__"